import { render, staticRenderFns } from "./ExamLink.vue?vue&type=template&id=75316f32"
var script = {}
import style0 from "./ExamLink.vue?vue&type=style&index=0&id=75316f32&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports